import { render, staticRenderFns } from "./cart-item.vue?vue&type=template&id=1518dcad&scoped=true&"
import script from "./cart-item.vue?vue&type=script&lang=js&"
export * from "./cart-item.vue?vue&type=script&lang=js&"
import style0 from "./cart-item.vue?vue&type=style&index=0&id=1518dcad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1518dcad",
  null
  
)

export default component.exports